// TODO: test
export const escapeLike = (val: string) => {
	return `%${val.replace('[', '[[').replace('%', '[%]').replace('_', '[_]')}%`;
};
